import styled from "styled-components";

export const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.colors.errorDark};
  font-size: 12px;
  margin-top: 4px;
`;

export const ParentDepartmentBox = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.aliceBlue};
  border: 1px solid ${(props) => props.theme.colors.clearBlue};
  margin-top: 8px;
  min-height: 40px;
  width: 100%;

  & > * {
    color: ${(props) => props.theme.colors.clearBlue};
    font-weight: 500;
  }
`;
